/**
 * =========================================================
 * LEKONAS FAQ PRO
 * assets/lekonas-faq-pro.js
 * =========================================================
 */

(() => {
  function initFaq(section) {
    if (!section || section.dataset.faqInitialized === "true") return;
    section.dataset.faqInitialized = "true";

    const allowMultiple =
      section.dataset.allowMultiple === "true";

    const items = [...section.querySelectorAll(".lekonas-faq__item")];
    const buttons = [...section.querySelectorAll(".lekonas-faq__question")];
    const search = section.querySelector(".lekonas-faq__search-input");
    const clearBtn = section.querySelector(".lekonas-faq__search-clear");
    const categories = [...section.querySelectorAll(".lekonas-faq__category")];
    const noResults = section.querySelector(".lekonas-faq__no-results");

    function openItem(item) {
      const button = item.querySelector(".lekonas-faq__question");
      const answer = item.querySelector(".lekonas-faq__answer");
      if (!button || !answer) return;

      if (!allowMultiple) {
        items.forEach((other) => {
          if (other !== item) closeItem(other);
        });
      }

      item.classList.add("is-open");
      button.setAttribute("aria-expanded", "true");
      answer.hidden = false;
    }

    function closeItem(item) {
      const button = item.querySelector(".lekonas-faq__question");
      const answer = item.querySelector(".lekonas-faq__answer");
      if (!button || !answer) return;

      item.classList.remove("is-open");
      button.setAttribute("aria-expanded", "false");
      answer.hidden = true;
    }

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const item = button.closest(".lekonas-faq__item");
        if (!item) return;

        if (item.classList.contains("is-open")) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });

    function filterFaq() {
      const term = search ? search.value.trim().toLowerCase() : "";

      const activeCategory =
        section.querySelector(".lekonas-faq__category.is-active")?.dataset.category || "all";

      let visible = 0;

      items.forEach((item) => {
        const text = item.textContent.toLowerCase();
        const category = item.dataset.category || "all";

        const termMatch =
          !term || text.includes(term);

        const categoryMatch =
          activeCategory === "all" || category === activeCategory;

        const show = termMatch && categoryMatch;

        item.hidden = !show;

        if (show) visible++;
      });

      if (noResults) {
        noResults.hidden = visible !== 0;
      }

      if (clearBtn) {
        clearBtn.hidden = !term;
      }
    }

    if (search) {
      search.addEventListener("input", filterFaq);
    }

    if (clearBtn) {
      clearBtn.addEventListener("click", () => {
        if (!search) return;
        search.value = "";
        search.focus();
        filterFaq();
      });
    }

    categories.forEach((category) => {
      category.addEventListener("click", () => {
        categories.forEach((c) => {
          c.classList.remove("is-active");
          c.setAttribute("aria-selected", "false");
        });

        category.classList.add("is-active");
        category.setAttribute("aria-selected", "true");

        filterFaq();
      });
    });

    filterFaq();
  }

  function initAll() {
    document
      .querySelectorAll("[data-faq-section]")
      .forEach(initFaq);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector("[data-faq-section]") || event.target;
    initFaq(section);
  });
})();
